<template>
  <div class="app-voucher-top-up-wrapper">
    <voucher-input v-if="showInput"
                   :placeholder="placeholder"
    >
      <template #txtBefore><slot name="voucherInputBefore"></slot></template>
      <template #lblInput><slot name="voucherInputLblInput"></slot></template>
      <template #btnNext><slot name="voucherInputBtnNext"></slot></template>
      <template #txtAfter><slot name="voucherInputAfter"></slot></template>
    </voucher-input>
    <voucher-thank-you v-if="showThankYou" previousStep="input" :show-logout="showLogout">
      <template #info><slot name="voucherThankYouInfo"></slot></template>
      <template #btnBack><slot name="voucherThankYouBtnBack"></slot></template>
    </voucher-thank-you>
  </div>
</template>
<script>
import VoucherInput, { stepName as inputStepName } from '@/components/process/generic/TopUp/Voucher/Input.vue'
import VoucherThankYou, { stepName as thankYouStepName } from '@/components/process/generic/TopUp/Voucher/ThankYou.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'VoucherTopUpWrapper',
  props: {
    placeholder: {
      type: String,
      default: 'Aufladecode'
    },
    showLogout: {
      type: Boolean,
      default: false
    }
  },
  components: { VoucherInput, VoucherThankYou },
  computed: {
    ...mapGetters('topUp', [
      'view'
    ]),
    showInput () {
      return this.view === inputStepName
    },
    showThankYou () {
      return this.view === thankYouStepName
    }
  }
}
</script>
